// extracted by mini-css-extract-plugin
module.exports = {"box":"box-39RwT1Pb","exPlanWrapper":"exPlanWrapper-15hluC9k"};